import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-4 rounded-md bg-gray-100" }

import { useToast } from 'vue-toastification';
import { ref } from 'vue';
import { useQueryClient } from '@tanstack/vue-query';
import { StudyPeriodSetup } from '@/types';
import ApiClient from '@/plugins/store/actions/api/ApiClient';
import { queryKeys } from '@/plugins/store/actions/queries/study-periods/index';
import { i18n } from '@/plugins/internationalization/i18n';
import CustomButton from '@/components/ui/CustomButton.vue';
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '@/components/ui/dialog';

interface Props {
    studyPeriodSetup: StudyPeriodSetup;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteSavedAnalysisDialog',
  props: /*@__PURE__*/_mergeModels({
    studyPeriodSetup: {}
  }, {
    "open": { type: Boolean, ...{ required: true } },
    "openModifiers": {},
  }),
  emits: ["update:open"],
  setup(__props: any) {

const props = __props;

const toast = useToast();

const isOpen = _useModel<boolean>(__props, 'open');

const isLoading = ref(false);

const queryClient = useQueryClient();

async function deleteStudyPeriodSetup() {
    try {
        if (isLoading.value) {
            return;
        }

        isLoading.value = true;

        await ApiClient.send('delete', `monitor/study-periods/setup/${props.studyPeriodSetup.id}`, {});

        queryClient.setQueryData(queryKeys.getStudyPeriodSetups(), (old: StudyPeriodSetup[] | undefined) => old?.filter((setup) => setup.id !== props.studyPeriodSetup.id));

        await queryClient.invalidateQueries({ queryKey: queryKeys.getStudyPeriodSetups() });

        toast.success(i18n.global.t('views.monitoring.teamComparison.dialogs.deleteSavedAnalysis.successMessage'));

        isOpen.value = false;
    } catch (err) {
        toast.error(i18n.global.t('views.monitoring.teamComparison.dialogs.deleteSavedAnalysis.errorMessage'));
    } finally {
        isLoading.value = false;
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), {
    modelValue: isOpen.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isOpen).value = $event)),
    disabled: isLoading.value
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogTitle), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.dialogs.deleteSavedAnalysis.title')), 1)
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogDescription), { class: "mt-2 text-gray-500" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.dialogs.deleteSavedAnalysis.description')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.studyPeriodSetup.name), 1),
      _createVNode(_unref(DialogFooter), { class: "flex sm:justify-center pt-2" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogClose), { "as-child": "" }, {
            default: _withCtx(() => [
              _createVNode(CustomButton, {
                "color-preset": "white",
                class: "min-w-44",
                disabled: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.dialogs.deleteSavedAnalysis.buttons.cancel')), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          }),
          _createVNode(CustomButton, {
            "color-preset": "warning",
            class: "min-w-44",
            loading: isLoading.value,
            onClick: deleteStudyPeriodSetup
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.teamComparison.dialogs.deleteSavedAnalysis.buttons.delete')), 1)
            ]),
            _: 1
          }, 8, ["loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "disabled"]))
}
}

})